<h2 class="heading-4">Your {{ vm.claimType }}</h2>

<p class="body mt-8">
  As you haven’t reached your plan’s start date, you can’t book
  {{ vm.claimType === 'repair' ? 'repairs' : 'a service' }} just yet.
</p>

<p class="body mt-8">
  You can find the start date on your <a class="link-text" (click)="onDownloadPlanDocs()()">plan documents</a>.
</p>
